module.exports = __webpack_public_path__ + "img/car3D.48f87339.jpeg";